import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/intellivynet.webp';
import screenshot_target from '../../../images/letterfunnel/markmaneschijn.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Mark Maneschijn"
      firstname="Mark"
      companyname="Intellivy.net"
      competition="PickFu en ProductPinion"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/markmaneschijn.js